import React from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import CadsAIAssignUIProvider from './CadsAIAssignUIProvider';
import { Col, Container, FormGroup, Input, Row } from 'reactstrap';
import AssignDialog from './assign-dialog/AssignDialog';
import { findDataInArray } from '@/shared/helpers';
import { setSelectedAssignProduct } from '@/containers/Cads-AI/redux/actions';
import { setActiveTab } from '@/containers/Cads-AI/ManageLearning/Assign/redux/actions';
import { CADS_AI_PRODUCTS } from '@/shared/helpers/constants';
import * as Constants from '@/shared/helpers/constants';
import { isEmpty } from 'lodash/lang';
import AssignWizardPage from './assign-wizard/AssignWizardPage';
import { paths } from '@/shared/helpers/paths';

const { COURSE, LEARNING_PATH } = CADS_AI_PRODUCTS;
const { COHORT, ORGANIZATION, USERS } = Constants.cadsAITabs;
const productList = [LEARNING_PATH, COURSE];
const cadsAIAssignBaseUrl = paths.CADS_AI.LEARNING.ASSIGN;
const AssignPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { activeTab } = useSelector((state) => state.cadsAIAssignPage, shallowEqual);
  const { checkedItemIds } = useSelector((state) => state.cadsAIAssignPage, shallowEqual);
  const { assignedProduct } = useSelector((state) => state.cadsAI, shallowEqual);
  const [selectedProduct, setSelectedProduct] = React.useState(assignedProduct);

  React.useEffect(() => {
    const activeTabParam = new URLSearchParams(location.search)?.get('activeTab');
    const unassignedProductId = new URLSearchParams(location.search)?.get('unassignmentFor');
    if (
      activeTabParam &&
      activeTabParam !== activeTab &&
      [USERS, COHORT, ORGANIZATION].includes(activeTab)
    ) {
      dispatch(setActiveTab(activeTab));
    }
    if (unassignedProductId) {
      const productIdx = productList.findIndex((product) => product.id === +unassignedProductId);
      if (productIdx !== -1 && productList[productIdx] !== selectedProduct)
        dispatch(setSelectedAssignProduct(productList[productIdx]));
    }
  }, [location.search, assignedProduct]);

  const assignUIEvents = {
    openAssignDialog: () => {
      history.push(`${cadsAIAssignBaseUrl}/confirm-assign`);
    },
  };

  const handleChange = ({ target: { value } }) => {
    const productId = +value;
    setSelectedProduct(productList.find((product) => product.id === productId));
    const product = findDataInArray(productList, productId, 'id');
    dispatch(setSelectedAssignProduct(product));
  };

  return (
    <CadsAIAssignUIProvider assignUIEvents={assignUIEvents}>
      <Switch>
        <Route path={`${cadsAIAssignBaseUrl}/confirm-assign`}>
          {({ history, match }) => {
            if (isEmpty(checkedItemIds)) history.push(cadsAIAssignBaseUrl);
            else
              return (
                <AssignDialog
                  show={match != null}
                  isEdit={false}
                  onHide={() => {
                    history.push(cadsAIAssignBaseUrl);
                  }}
                />
              );
          }}
        </Route>
      </Switch>

      <Col md={12} lg={12}>
        <Container>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Row>
                  <Col sm={9}>
                    <h3 className="page-title">{selectedProduct.name}</h3>
                    <h3 className="page-subhead subhead">
                      From here you can manage the assignment for{' '}
                      {selectedProduct.name?.toLowerCase()}.
                    </h3>
                  </Col>
                  <Col sm={3}>
                    Assignment For
                    <Input
                      id="assignProductSelect"
                      name="select"
                      type="select"
                      value={selectedProduct.id}
                      onChange={handleChange}
                    >
                      {productList.map(({ id, name }) => (
                        <option key={id} value={id}>
                          {name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
              </FormGroup>
            </Col>
            <AssignWizardPage selectedProduct={selectedProduct} />
          </Row>
        </Container>
      </Col>
    </CadsAIAssignUIProvider>
  );
};

export default AssignPage;
